import LoginStyles from '../Login.module.scss';
import { LoginPageContainer } from '../LoginPageContainer';
import { useTranslation } from 'react-i18next';
import imgEmailConfirmed from '../../assets/images/auth/email-confirmed.svg';
import { ConfirmationMessageWithAction } from './ConfirmationMessageWithAction';

export const PasswordHasBeenSetPage = () => {
  const i18n = useTranslation();

  return (
    <LoginPageContainer additionalClass={LoginStyles.confirmationPage}>
      <ConfirmationMessageWithAction
        image={imgEmailConfirmed}
        title={i18n.t('Login_PasswordHasBeenSetPage_Title')}
      />
    </LoginPageContainer>
  );
};
